<div class="d-none d-print-block p-3" *ngIf="hasDio()">
    <table class="border-top">
        <tbody>
            <tr class="text-center">
                <td rowspan="2">
                    <img src="assets/img/logo.png" alt="Logo" height="35">
                </td>
                <td rowspan="2" colspan="2">Diário de Operações</td>
                <td>Emissão</td>
                <td>Impresso</td>
                <td>DIO nº</td>
            </tr>
            <tr class="text-center">
                <td class="fw-bold">{{ dio.created_at | date:'short' }}</td>
                <td class="fw-bold">{{ now | date:'short' }}</td>
                <td class="fw-bold">{{ dio.numero }}</td>
            </tr>
            <tr>
                <td>Orgão Requisitante</td>
                <td colspan="5" class="fw-bold">{{ dio.orgao.nome | uppercase }}</td>
            </tr>
            <tr>
                <td>Proprietário</td>
                <td colspan="5" class="fw-bold">{{ dio.contrato.beneficiaria.nome | uppercase }}</td>
            </tr>
            <tr>
                <td>Contrato</td>
                <td colspan="5" class="fw-bold">{{ dio.contrato.nome | uppercase }}</td>
            </tr>
            <tr>
                <td>Descrição do Serviço</td>
                <td colspan="5" class="fw-bold">{{ dio.servico.descricao | uppercase }}</td>
            </tr>
            <tr>
                <td>Operador</td>
                <td colspan="5" class="fw-bold">
                    {{ dio.condutor.firstName | uppercase }} {{ dio.condutor.lastName | uppercase }}
                </td>
            </tr>
            <tr>
                <td>Local de Apresentação</td>
                <td colspan="5" class="fw-bold">{{ dio.localApresentacao ? ( dio.localApresentacao.nome | uppercase) : '---' }}</td>
            </tr>
            <tr>
                <td>Identificador SEI</td>
                <td colspan="2" class="fw-bold">{{ dio.sei }}</td>
                <td>Processo SEI</td>
                <td colspan="2" class="fw-bold">{{ dio.precessoSei }}</td>
            </tr>
            <tr class="text-center">
                <td colspan="6">Identificação do equipamento</td>
            </tr>
            <tr>
                <td>Grupo</td>
                <td>Prefixo</td>
                <td>Placa/Série</td>
                <td>Marca</td>
                <td>Modelo</td>
                <td>Ano</td>
            </tr>
            <tr class="text-center">
                <td class="fw-bold">
                    <span *ngIf="dio.alocacao">{{ dio.alocacao.equipamento.grupo.nome | uppercase }}</span>
                </td>
                <td class="fw-bold">
                    <span *ngIf="dio.alocacao">{{ dio.alocacao.codigo | uppercase}}</span>
                </td>
                <td class="fw-bold">
                    <span *ngIf="dio.alocacao">{{ dio.alocacao.equipamento.placa }}</span>
                </td>
                <td class="fw-bold">
                    <span *ngIf="dio.alocacao">{{ dio.alocacao.equipamento.marca | uppercase }}</span>
                </td>
                <td class="fw-bold">
                    <span *ngIf="dio.alocacao">{{ dio.alocacao.equipamento.modelo | uppercase }}</span>
                </td>
                <td class="fw-bold">
                    <span *ngIf="dio.alocacao">{{ dio.alocacao.equipamento.fabricacaoAno }}</span>
                </td>
            </tr>
        </tbody>
    </table>

    <!-- DADOS GERAIS -->
    <table>
        <tbody>
            <tr class="text-center">
                <td colspan="4">Dados Gerais</td>
            </tr>
            <tr>
                <td>Beneficiária (CNPJ)</td>
                <td class="fw-bold">{{ dio.contrato?.beneficiaria?.cnpj | mask:'CPF_CNPJ' }}</td>
                <td>Condutor (email)</td>
                <td class="fw-bold">{{ dio.condutor?.email || '---' }}</td>
            </tr>
            <tr>
                <td>Demandante</td>
                <td class="fw-bold">{{ dio.demandante?.nome || '---' }}</td>
                <td>Região</td>
                <td class="fw-bold">{{ dio.regiaoAdm?.nome || '---' }}</td>
            </tr>
            <tr>
                <td>Executor Local</td>
                <td class="fw-bold">{{ dio.funcionarioResponsavelOrgao || '---' }}</td>
                <td>Orgão</td>
                <td class="fw-bold">{{ dio.orgao?.nome || '---' }}</td>
            </tr>
            <tr>
                <td>Local de Apresentação</td>
                <td class="fw-bold">{{ dio.localApresentacao?.nome || '---' }}</td>
                <td>Região Adm. do Orgão</td>
                <td class="fw-bold">{{ dio.regiaoAdm?.nome || '---' }}</td>
            </tr>
            <tr>
                <td>Criado por</td>
                <td class="fw-bold">{{ dio.criadorNome || '---' }}</td>
                <td>Criado em</td>
                <td class="fw-bold">{{ dio.created_at ? (dio.created_at | date:'dd/MM/yyyy HH:mm:ss') : '---' }}</td>
            </tr>
            <tr>
                <td>Criador (email)</td>
                <td class="fw-bold">{{ dio.criadorEmail || '---' }}</td>
                <td>Status Execução</td>
                <td class="fw-bold">{{ dio.statusExecucao | translate }}</td>
            </tr>
        </tbody>
    </table>

    <!-- OPERAÇÕES EM SERVIÇO -->
    <table>
        <tbody>
            <tr class="text-center">
                <td colspan="8">Operações em Serviço</td>
            </tr>
            <tr class="text-center">
                <td colspan="2">Hora</td>
                <td colspan="4">Natureza</td>
                <td rowspan="2">Usuário</td>
                <td rowspan="2">Descrição detalhada</td>
            </tr>
            <tr class="text-center">
                <td>Inicio</td>
                <td>Fim</td>
                <td>HT</td>
                <td>HP</td>
                <td>HM</td>
                <td>HQ</td>
            </tr>
            <tr class="text-center" *ngIf="!dio.execucaoDetalhes || !dio.execucaoDetalhes.length">
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
            </tr>
            <tr class="text-center" *ngFor="let execucao of dio.execucaoDetalhes">
                <td>{{ execucao.created_at | date:'short' }}</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>{{ execucao.descricao }}</td>
            </tr>
        </tbody>
    </table>
    <table>
        <tbody>
            <tr>
                <td>Executor Local</td>
                <td>&nbsp;</td>
                <td>Data/Hora</td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td>Fiscal</td>
                <td>&nbsp;</td>
                <td>Data/Hora</td>
                <td>&nbsp;</td>
            </tr>
        </tbody>
    </table>

    <!-- RESUMO DA EXECUÇÃO -->
    <table>
        <tbody>
            <tr class="text-center">
                <td colspan="4">Resumo da Execução</td>
            </tr>
            <tr>
                <td>Início</td>
                <td class="fw-bold">{{ dio.dataInicioExecucao ? (dio.dataInicioExecucao | date:'dd/MM/yyyy HH:mm:ss') : '---' }}</td>
                <td>Fim</td>
                <td class="fw-bold">{{ dio.dataFimExecucao ? (dio.dataFimExecucao | date:'dd/MM/yyyy HH:mm:ss') : '---' }}</td>
            </tr>
            <tr>
                <td>Total Hora Disponível</td>
                <td class="fw-bold">{{ dio.totalHoraDisponivel || '---' }}</td>
                <td>Status Conclusão</td>
                <td class="fw-bold">{{ dio.statusConclusao ? (dio.statusConclusao | translate) : '---' }}</td>
            </tr>
            <tr>
                <td>Status Execução</td>
                <td class="fw-bold">{{ dio.statusExecucao | translate }}</td>
                <td>Motivo Desvio</td>
                <td class="fw-bold">{{ dio.motivoDesvio || '---' }}</td>
            </tr>
            <tr *ngIf="cancelamentos && cancelamentos.length">
                <td>Cancelamentos</td>
                <td colspan="3" class="fw-bold">
                    <div *ngFor="let cancelamento of cancelamentos">
                        {{ cancelamento.motivo }} ({{ cancelamento.created_at | date:'dd/MM/yyyy HH:mm:ss' }})
                    </div>
                </td>
            </tr>
            <tr *ngIf="dio.alocacao">
                <td>Hodômetro Inicial</td>
                <td class="fw-bold">{{ dio.hodometroInicial ? dio.hodometroInicial + ' km' : '---' }}</td>
                <td>Hodômetro Final</td>
                <td class="fw-bold">{{ dio.hodometroFinal ? dio.hodometroFinal + ' km' : '---' }}</td>
            </tr>
            <tr *ngIf="dio.alocacao">
                <td>Horímetro Inicial</td>
                <td class="fw-bold">{{ dio.horimetroInicial ? dio.horimetroInicial + ' horas' : '---' }}</td>
                <td>Horímetro Final</td>
                <td class="fw-bold">{{ dio.horimetroFinal ? dio.horimetroFinal + ' horas' : '---' }}</td>
            </tr>
            <tr *ngIf="dio.alocacao">
                <td>Total Odômetro Condutor</td>
                <td class="fw-bold">{{ dio.hodometroInicial && dio.hodometroFinal ? (dio.hodometroFinal - dio.hodometroInicial) + ' km' : '---' }}</td>
                <td>Total Horímetro</td>
                <td class="fw-bold">{{ dio.horimetroInicial && dio.horimetroFinal ? (dio.horimetroFinal - dio.horimetroInicial) + ' horas' : '---' }}</td>
            </tr>
            <tr>
                <td>Total Odômetro GPS</td>
                <td class="fw-bold">{{ execucaoGPS?.kmRodados ? execucaoGPS?.kmRodados + ' km' : '---' }}</td>
                <td>Detalhes Execução (imagens)</td>
                <td class="fw-bold">{{ dio.execucaoDetalhesValida?.imagens?.length || 0 }}</td>
            </tr>
            <tr>
                <td>Início da Operação</td>
                <td class="fw-bold">{{ dio.dataPeriodoInicioOperacao ? (dio.dataPeriodoInicioOperacao | date:'dd/MM/yyyy') : '---' }}</td>
                <td>Fim da Operação</td>
                <td class="fw-bold">{{ dio.dataPeriodoFimOperacao ? (dio.dataPeriodoFimOperacao | date:'dd/MM/yyyy') : '---' }}</td>
            </tr>
        </tbody>
    </table>

    <!-- TARIFAÇÃO -->
    <table *ngIf="showTarifacoes">
        <tbody>
            <tr class="text-center">
                <td colspan="4">Tarifação</td>
            </tr>
            <tr *ngIf="dio.alocacao?.grupoTarifacaoTipo === 'MAQUINAS'">
                <td>Valor/Hora Disponível Máquina</td>
                <td class="fw-bold">{{ dio.alocacao?.valorHoraDisponivelMaquina | currency:'BRL' }}</td>
                <td>Valor/Hora Funcionamento Máquina</td>
                <td class="fw-bold">{{ dio.alocacao?.valorHoraProduzida | currency:'BRL' }}</td>
            </tr>
            <tr *ngIf="dio.alocacao?.grupoTarifacaoTipo === 'VEICULOS'">
                <td>Valor/Hora Disponível Veículo</td>
                <td class="fw-bold">{{ dio.alocacao?.valorHoraDisponivelVeiculo | currency:'BRL' }}</td>
                <td>Valor/Hora Km Rodado</td>
                <td class="fw-bold">{{ dio.alocacao?.valorKmRodado | currency:'BRL' }}</td>
            </tr>
        </tbody>
    </table>

    <!-- USO DO EQUIPAMENTO -->
    <table *ngIf="showUsoEquipamento">
        <tbody>
            <tr class="text-center">
                <td colspan="4">Uso do Equipamento</td>
            </tr>
            <tr>
                <td>Tipo do Equipamento</td>
                <td class="fw-bold">{{ dio.alocacao?.grupoTarifacaoTipo || '---' }}</td>
                <td>Tipo Execução</td>
                <td class="fw-bold">{{ dio.execucaoDetalhesValida?.tipo || '---' }}</td>
            </tr>
            <tr>
                <td>Tempo de Disponibilidade</td>
                <td class="fw-bold">{{ formatHumanTime(dio.execucaoDetalhesValida?.disponibilidadeTotalMinutes) }}</td>
                <td>Tempo de Funcionamento</td>
                <td class="fw-bold">{{ formatHumanTime(dio.execucaoDetalhesValida?.funcionamentoTotalMinutes) }}</td>
            </tr>
            <tr *ngIf="dio.alocacao?.grupoTarifacaoTipo === 'VEICULOS'">
                <td>KM Rodados</td>
                <td class="fw-bold">{{ dio.execucaoDetalhesValida?.kmRodados ? dio.execucaoDetalhesValida?.kmRodados + ' km' : '---' }}</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
            </tr>
        </tbody>
    </table>

    <!-- PRECIFICAÇÃO -->
    <table *ngIf="showPrecificacoes">
        <tbody>
            <tr class="text-center">
                <td colspan="6">Precificação</td>
            </tr>
            <ng-container *ngFor="let precificacao of precificacoes">
                <tr>
                    <td>Tipo Precificação</td>
                    <td class="fw-bold" colspan="2">{{ precificacao.tipoPrecificacao | translate }}</td>
                    <td>Tipo</td>
                    <td class="fw-bold" colspan="2">{{ precificacao.precificacaoManual ? 'MANUAL' : 'AUTOMATICA' }}</td>
                </tr>
                <tr>
                    <td>Total Disponibilidade Máquina</td>
                    <td class="fw-bold">{{ precificacao.valorTotalDisponibilidadeMaquina | currency:'BRL' }}</td>
                    <td>Total Disponibilidade Veículo</td>
                    <td class="fw-bold">{{ precificacao.valorTotalDisponibilidadeVeiculo | currency:'BRL' }}</td>
                    <td>Total</td>
                    <td class="fw-bold">{{
                        (precificacao.valorTotalDisponibilidadeMaquina +
                        precificacao.valorTotalDisponibilidadeVeiculo +
                        precificacao.valorTotalProduzido +
                        precificacao.valorTotalKmRodado) | currency:'BRL'
                    }}</td>
                </tr>
                <tr>
                    <td>Total Funcionamento</td>
                    <td class="fw-bold">{{ precificacao.valorTotalProduzido | currency:'BRL' }}</td>
                    <td>Total KM Rodado</td>
                    <td class="fw-bold">{{ precificacao.valorTotalKmRodado | currency:'BRL' }}</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                </tr>
            </ng-container>
        </tbody>
    </table>

    <!-- ASSINATURAS -->
    <table>
        <tbody>
            <tr class="text-center">
                <td colspan="4">Assinaturas</td>
            </tr>
            <tr *ngFor="let assinatura of dio.assinaturas">
                <td>Role</td>
                <td class="fw-bold">{{ assinatura.role | translate | uppercase }}</td>
                <td>Usuário</td>
                <td class="fw-bold">{{ abreviateName(assinatura.userName) | titlecase }}</td>
            </tr>
            <tr *ngFor="let assinatura of dio.assinaturas">
                <td>Observação</td>
                <td class="fw-bold" colspan="3">{{ assinatura.observacao || 'Nenhuma observação' }}</td>
            </tr>
            <tr *ngFor="let assinatura of dio.assinaturas">
                <td>Data</td>
                <td class="fw-bold" colspan="3">{{ assinatura.created_at ? (assinatura.created_at | date:'dd/MM/yyyy HH:mm:ss') : '---' }}</td>
            </tr>
            <tr *ngIf="!dio.assinaturas || !dio.assinaturas.length">
                <td colspan="4" class="text-center">Nenhuma assinatura encontrada</td>
            </tr>
        </tbody>
    </table>

    <!-- MAPA -->
    <table *ngIf="showMapa">
        <tbody>
            <tr class="text-center">
                <td colspan="2">Mapa</td>
            </tr>
            <tr>
                <td>Rota</td>
                <td class="fw-bold">/dio/{{ dio.id }}/mapa</td>
            </tr>
        </tbody>
    </table>

    <!-- IMAGENS -->
    <table *ngIf="imagens && imagens.length">
        <tbody>
            <tr class="text-center">
                <td colspan="3">Imagens</td>
            </tr>
            <tr>
                <td>Descrição</td>
                <td>Alt</td>
                <td>URL</td>
            </tr>
            <tr *ngFor="let imagem of imagens">
                <td class="fw-bold">{{ imagem.descricao || '---' }}</td>
                <td class="fw-bold">{{ imagem.alt || '---' }}</td>
                <td class="fw-bold">{{ imagem.url || '---' }}</td>
            </tr>
        </tbody>
    </table>

    <!-- APONTAMENTOS -->
    <table *ngIf="showApontamentos">
        <tbody>
            <tr class="text-center">
                <td colspan="7">Apontamentos</td>
            </tr>
            <tr>
                <td>Início</td>
                <td>Fim</td>
                <td *ngIf="isVeiculo()">KM</td>
                <td *ngIf="isMaquina()">Horas Trabalhadas</td>
                <td *ngIf="!isVeiculo() && !isMaquina()">KM/Horas</td>
                <td>Horas Disponíveis</td>
                <td>Motivo</td>
                <td>Responsável</td>
            </tr>
            <tr *ngFor="let apontamento of apontamentos">
                <td class="fw-bold">{{ apontamento.dataInicio | date:'dd/MM/yyyy HH:mm' }}</td>
                <td class="fw-bold">{{ apontamento.dataFim | date:'dd/MM/yyyy HH:mm' }}</td>
                <td class="fw-bold" *ngIf="isVeiculo()">{{ apontamento.totalKmRodadosCancelados }}</td>
                <td class="fw-bold" *ngIf="isMaquina()">{{ apontamento.totalHorasTrabalhadasCanceladas }}</td>
                <td class="fw-bold" *ngIf="!isVeiculo() && !isMaquina()">---</td>
                <td class="fw-bold">{{ apontamento.totalHorasDisponiveisCanceladas }}</td>
                <td class="fw-bold">{{ apontamento.motivo }}</td>
                <td class="fw-bold">
                    {{ apontamento.usuarioResponsavelNome }}
                    <span *ngIf="apontamento.usuarioResponsavelAferidorNumero">
                        (Aferidor: {{ apontamento.usuarioResponsavelAferidorNumero }})
                    </span>
                </td>
            </tr>
            <tr *ngIf="!apontamentos || !apontamentos.length">
                <td colspan="7" class="text-center">Nenhum apontamento encontrado</td>
            </tr>
        </tbody>
    </table>

    <!-- OBSERVAÇÕES -->
    <table *ngIf="showObservacoes">
        <tbody>
            <tr class="text-center">
                <td colspan="3">Observações</td>
            </tr>
            <tr>
                <td>Data</td>
                <td>Observação</td>
                <td>Responsável</td>
            </tr>
            <tr *ngFor="let observacao of observacoes">
                <td class="fw-bold">{{ observacao.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
                <td class="fw-bold">{{ observacao.textoObservacao }}</td>
                <td class="fw-bold">{{ observacao.responsavel }}</td>
            </tr>
            <tr *ngIf="!observacoes || !observacoes.length">
                <td colspan="3" class="text-center">Nenhuma observação encontrada</td>
            </tr>
        </tbody>
    </table>

    <!-- HISTÓRICO DE EVENTOS -->
    <table *ngIf="eventos && eventos.length">
        <tbody>
            <tr class="text-center">
                <td colspan="6">Histórico de Eventos</td>
            </tr>
            <tr>
                <td>Tipo</td>
                <td>Data</td>
                <td>Status Execução</td>
                <td>Status Conclusão</td>
                <td>Status Aferição</td>
                <td>Usuário</td>
            </tr>
            <tr *ngFor="let evento of eventos">
                <td class="fw-bold">{{ evento.tipoEvento | translate }}</td>
                <td class="fw-bold">{{ evento.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                <td class="fw-bold">{{ evento.statusExecucaoAtual ? (evento.statusExecucaoAtual | translate) : '---' }}</td>
                <td class="fw-bold">{{ evento.statusConclusaoAtual ? (evento.statusConclusaoAtual | translate) : '---' }}</td>
                <td class="fw-bold">{{ evento.statusAfericaoAtual ? (evento.statusAfericaoAtual | translate) : '---' }}</td>
                <td class="fw-bold">{{ evento.usuarioNome || '---' }}</td>
            </tr>
        </tbody>
    </table>

    <!-- AFERIÇÃO -->
    <table *ngIf="showAfericao && dio.statusAfericao">
        <tbody>
            <tr class="text-center">
                <td colspan="4">Aferição</td>
            </tr>
            <tr>
                <td>Status Aferição</td>
                <td class="fw-bold">{{ dio.statusAfericao | translate }}</td>
                <td>Aferidor</td>
                <td class="fw-bold">
                    {{ dio.afericao?.aferidor?.firstName ? (dio.afericao?.aferidor?.firstName + ' ' + dio.afericao?.aferidor?.lastName) : '---' }}
                </td>
            </tr>
            <tr>
                <td>Data Disponibilização</td>
                <td class="fw-bold">{{ dio.afericao?.dataDisponibilizacao ? (dio.afericao?.dataDisponibilizacao | date:'short') : '---' }}</td>
                <td>Data Aferição</td>
                <td class="fw-bold">{{ dio.afericao?.dataFinalizacao ? (dio.afericao?.dataFinalizacao | date:'short') : '---' }}</td>
            </tr>
            <tr *ngIf="showVerAfericao">
                <td>Rota</td>
                <td colspan="3" class="fw-bold">/dio/{{ dio.id }}/aferir</td>
            </tr>
        </tbody>
    </table>
    <div class="d-flex justify-content-between pt-1">
        <div>
            Emitido por <span class="fw-bold">{{ dio.criadorNome | uppercase }}</span>
        </div>
        <div>
            Impresso por <span class="fw-bold">{{ authService.user.name | uppercase }}</span>
        </div>
    </div>
</div>